import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import LoaderSpinner from "@components-shared/LoaderSpinner";
import AdminLayoutWrapper from "@components/layout/AdminLayoutWrapper";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import { useRootAppStore } from "@hooks";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { GamingHistoryStoreContext } from "@state/context/games";
import { GamingHistoryStore } from "@state/stores/games/history";
import { setTabTitle } from "@utils";
import { observer } from "mobx-react";

import GamingHistoryBody from "./GamingHistoryBody";
import GamingHistoryHeader from "./GamingHistoryHeader";
import GamingHistoryTabSwitcher from "./GamingHistoryTabSwitcher";
import GamingHistoryTabs from "./GamingHistoryTabs";

export const GamingHistoryPage = observer(function GamingHistoryPage() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	const gamingHistoryStore = useMemo(
		() => new GamingHistoryStore(rootStore),
		[]
	);

	useScrollRestoration({ type: ConfigType.Basic });

	useEffect(() => {
		setTabTitle(t("GAMING_HISTORY.TITLE"));
		gamingHistoryStore.onInitialize();

		return () => {
			gamingHistoryStore.onDispose();
		};
	}, []);

	const {
		isStoreInitialized,
		isLoading: isLiveCasinoFormLoading,
		gamingHistoryFilterStore: { isLoading: isCasinoFormLoading },
	} = gamingHistoryStore;

	if (
		!isStoreInitialized &&
		!isCasinoFormLoading &&
		!isLiveCasinoFormLoading
	) {
		return null;
	}

	return (
		<AdminLayoutWrapper>
			<GamingHistoryStoreContext.Provider value={gamingHistoryStore}>
				<LoaderSpinner
					isLoading={isCasinoFormLoading || isLiveCasinoFormLoading}
				/>
				<div className="container">
					<div id="betsDiv" className="container">
						<div className="card--primary">
							<GamingHistoryHeader />

							<GamingHistoryTabSwitcher />

							<GamingHistoryTabs />
						</div>

						<GamingHistoryBody />
					</div>
				</div>
			</GamingHistoryStoreContext.Provider>
		</AdminLayoutWrapper>
	);
});
